module.exports = __webpack_public_path__ + "static/media/policeCar_navy.da9c3be6.svg";